import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { Component } from 'react';
import DashLabel from './DashLabel';
import { MdOutlineTimer, MdPhoneAndroid } from 'react-icons/md';
import { httpGet, httpPost } from '../util/http';
import moment from 'moment';
import { PieChart } from '@mui/x-charts';
import { BsBuilding, BsBuildings } from 'react-icons/bs';

export default class DashStatus extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            stats: {
                unidades: 0,
                depositos: 0,
                deps_em_contagem: 0,
            }
        }
    }

    componentDidMount() {
        this.refresh();
        this.timer = setInterval(() => {
            this.refresh();
        }, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    refresh() {
        httpPost('/statistics/dash',
            {},
            stats => {
                //console.log(stats)
                this.setState({
                    stats,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    render() {
        return (
            <>
                {this.state.loading ? <Skeleton height={206} variant="rounded" /> :
                    <Stack padding={2} borderRadius={5} direction="row" gap={1} bgcolor="mariano.secondary">
                        <Box>
                            <Typography color="primary" variant="caption"><b>Depósitos em inventário</b></Typography>
                            <PieChart
                                series={[
                                    {
                                        data: [{ id: 0, color: '#d32f2f', value: this.state.stats.deps_em_contagem, label: 'Em contagem de estoques' },
                                        { id: 1, color: '#2e7d32', value: (this.state.stats.depositos - this.state.stats.deps_em_contagem), label: 'Em operação normal' }],
                                        highlightScope: { faded: 'global', highlighted: 'item' },
                                        faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                                    },
                                ]}
                                height={150}
                                width={250}
                                slotProps={{
                                    legend: { hidden: true },
                                }}
                            />
                        </Box>
                        <Stack gap={4} flex={1}>
                            <Stack flex={1} direction="row" maxHeight={206}>
                                <DashLabel icon={BsBuildings} title="Unidades" subtitle={this.state.stats.unidades + ' unids.'} />
                                <DashLabel icon={BsBuilding} title="Depósitos" subtitle={this.state.stats.depositos + ' deps.'} />
                                {/* <DashLabel icon={MdMoving} title="Relação sobra/falta*" subtitle="0.8" /> */}
                                <Box component="img" zIndex={2} sx={{ mt: 13, mr:5 }} src="res/box.png" height={150} />
                            </Stack>
                        </Stack>
                    </Stack>

                }
            </>
        );
    }
}